import { render, staticRenderFns } from "./sendmessage.vue?vue&type=template&id=7665dabd&"
import script from "./sendmessage.vue?vue&type=script&lang=js&"
export * from "./sendmessage.vue?vue&type=script&lang=js&"
import style0 from "./sendmessage.vue?vue&type=style&index=0&lang=less&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports